export default import.meta.ROLLDOWN_FILE_URL_7jlqM3oeOeY$T94puST3wQ